import { render, staticRenderFns } from "./TravelServiceOrderItemOtherChip.vue?vue&type=template&id=95901bcc&scoped=true&"
import script from "./TravelServiceOrderItemOtherChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemOtherChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95901bcc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95901bcc')) {
      api.createRecord('95901bcc', component.options)
    } else {
      api.reload('95901bcc', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemOtherChip.vue?vue&type=template&id=95901bcc&scoped=true&", function () {
      api.rerender('95901bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemOtherChip.vue"
export default component.exports